import React from 'react';
import { Router } from "@reach/router"

import PrivateRoute from './components/PrivateRoute';

import SignIn from './pages/SignIn';

import AppFrame from './components/AppFrame/AppFrame';
import Dashboard from './pages/Dashboard/Dashboard';
import Users from './pages/Users/Users';
import UserDetails from './pages/UserDetails/UserDetails';
import Chat from './pages/ChatMessages/ChatMessages';
import { DialogConsumer } from './components/DialogProvider';
import Chats from './pages/Chats/Chats';
import Support from './pages/Support/Support';
import Photos from './pages/Photos/Photos';
import ReportedUsers from './pages/ReportedUsers/ReportedUsers';

const AppRoutes = () => (
  <AppFrame>
    <Router>
      <Dashboard path="/" />
      <Users path="/users" />
      <UserDetails path="/users/:userId" />
      <Chats path="/chats" />
      <Chat path="/chats/:chatId" />
      <Support path="/support" />
      <Photos path="/photos" />
      <ReportedUsers path="/reported-users" />
    </Router>
    <DialogConsumer />
  </AppFrame>
)

function App() {
  return (
    <Router>
      <SignIn path="/sign-in" />
      <PrivateRoute path="/" default component={AppRoutes} />
    </Router>
  );
}

export default App;
